






















import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import { childEZAvgScore } from '@/api/teachingProtection/assessment'
import BasePanel from '@/components/BasePanel/index.vue'
import AvgScore from '../../_components/AvgScore.vue'
import Radar from '../../_components/charts/Radar.vue'
import BarDifference from '../../_components/charts/BarDifference.vue'

  @Component({
    components: {
      BasePanel,
      AvgScore,
      Radar,
      BarDifference
    }
  })
export default class extends Vue {
    @Prop({ required: true }) private energyZoneType!: any
    private pieData: any = {
      others: [],
      details: []
    }
    private colorList: any = []
    private barDataArray: Array < object > = []
    // get type() {
    //   return this.$route.query.type
    // }
    created() {
      if (!this.$route.query.searchParams) return
      let params = JSON.parse(this.$route.query.searchParams as string)
      childEZAvgScore({ ...params, energyZoneType: this.energyZoneType }).then(res => {
        this.pieData = res.data.branchEZAvgScore
        this.barDataArray = res.data.barChart || []
      })
      // let obj: any = this.data.pie
      // obj.HeightLastTypeIntro = obj.title
      // obj.data = []
      // this.data.pie.dataList.map(v => {
      //   obj.data.push({ name: v.name, value: v.value * 100 })
      // })
      // this.list.push(obj)
      // this.data.staminaHeightPercentVoLine.map(v => {
      //   this.list.push(v)
      // })
    }
}
